module.exports = __webpack_public_path__ + "img/load.13e76c4e.gif";